var map = {
	"./logo-aliments-sante-horizontal.svg": "37ab",
	"./logo-aliments-sante.svg": "91fd",
	"./logo-canada.svg": "4ceb",
	"./logo-cantine.png": "8731",
	"./logo-cibim.svg": "5cc8",
	"./logo-defi-ville-intelligente-cropped.png": "024a",
	"./logo-defi-ville-intelligente.png": "2d6c",
	"./logo-montreal.png": "2d7c",
	"./logo-mtl-en-commun-cropped.png": "82e0",
	"./logo-mtl-en-commun.png": "2c97",
	"./logo-mutuali-cibim.svg": "708d",
	"./logo-mutuali.svg": "de1e",
	"./logo-rtcbq.png": "f452"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";